import React, { useEffect, useState } from "react";
import Dropdown from "../dropdown";
import { PointIcon } from "../../assets/images";
import { arrowDown } from "../../assets/images/index";
import "./phone-input.scss";
import { useLayoutContext } from "../../layouts/general-layout"; // Import context

export interface CountryOption {
  code: string;
  label: string;
  value: string;
  flag: string;
  dialCode: string;
}

interface Props {
  phone: string;
  countryCode: string;
  onPhoneChange: (value: string) => void;
  onCountryCodeChange: (value: string) => void;
  countryOptions?: CountryOption[];
  onValidChange?: (isValid: boolean) => void;
}

const PhoneInput: React.FC<Props> = ({
  phone,
  countryCode,
  onPhoneChange,
  onCountryCodeChange,
  countryOptions = [{
    code: "IL",
    label: "Israel",
    flag: "https://flagcdn.com/w20/il.png",
    value: "+972",
    dialCode: "+972"
  }],
  onValidChange
}) => {
  const [localPhone, setLocalPhone] = useState("");
  const { t } = useLayoutContext();

  useEffect(() => {
    const cleanCountry = countryCode.replace("+", "");
    if (phone.startsWith(cleanCountry)) {
      setLocalPhone(phone.slice(cleanCountry.length));
    } else {
      setLocalPhone(phone);
    }
  }, [phone, countryCode]);

  const handlePhoneInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const clean = e.target.value.replace(/\D/g, "");
    setLocalPhone(clean);
    const full = countryCode.replace("+", "") + clean;
    onPhoneChange(full);
    const isValid = validatePhone(clean, countryCode);
    onValidChange?.(isValid);
  };

  const validatePhone = (clean: string, code: string) => {
    if (code === "+972") {
      return clean.length >= 9 && clean.length <= 10;
    }
    return clean.length >= 8 && clean.length <= 15;
  };

  return (
    <div className="phone-input-container">
      <div className="custom-phone-input">
        <div className="phone-field form-field">
          <input
            value={localPhone}
            onChange={handlePhoneInputChange}
            placeholder={t("phone")}
            maxLength={15}
          />
        </div>
        <div className="country-dropdown">
          <Dropdown
            label=""
            value={countryCode}
            options={countryOptions.map(({ value, label, dialCode, flag }) => ({
              value: dialCode,
              label: `${flag} ${dialCode}`,
              labelNode: (
                <div className="country-option">
                  <span className="code">{dialCode}</span>
                  <img src={flag} alt={`${label} flag`} className="flag" />
                </div>
              ),
            }))}
            onChange={(val) => onCountryCodeChange(val.toString())}
          />

        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
